export const CHATBOT_CONTENT_MESSAGE_TYPE = "conectado:open-content";

const PRODUCTION_APP_ORIGIN = "https://app-conectado.connectapps.com.br";

const asPositiveInteger = (value: unknown) => {
  const number = typeof value === "number" ? value : Number(value);

  return Number.isInteger(number) && number > 0 ? number : undefined;
};

export const decodeChatbotContentId = (encodedId: string) => {
  try {
    const decodedSegment = decodeURIComponent(encodedId).trim();
    const normalizedBase64 = decodedSegment.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - (normalizedBase64.length % 4)) % 4);
    const decodedId = window.atob(`${normalizedBase64}${padding}`).trim();

    if (!/^\d+$/.test(decodedId)) return undefined;

    return asPositiveInteger(decodedId);
  } catch {
    return undefined;
  }
};

export const isTrustedChatbotContentOrigin = (origin: string) =>
  origin === window.location.origin || origin === PRODUCTION_APP_ORIGIN;

export const getChatbotContentIdFromUrl = (value: string) => {
  try {
    const url = new URL(value, window.location.origin);
    if (!isTrustedChatbotContentOrigin(url.origin)) return undefined;

    const legacyMatch = url.pathname.match(/^\/conteudo\/([^/]+)\/?$/);
    if (legacyMatch) return decodeChatbotContentId(legacyMatch[1]);

    const detailsMatch = url.pathname.match(
      /^\/app\/conteudo\/detalhes\/conteudos\/(\d+)\/?$/
    );

    return detailsMatch ? asPositiveInteger(detailsMatch[1]) : undefined;
  } catch {
    return undefined;
  }
};

export const getChatbotContentIdFromMessage = (value: unknown) => {
  if (typeof value === "string") return getChatbotContentIdFromUrl(value);
  if (!value || typeof value !== "object") return undefined;

  const message = value as {
    contentId?: unknown;
    href?: unknown;
    type?: unknown;
    url?: unknown;
  };

  if (message.type === CHATBOT_CONTENT_MESSAGE_TYPE) {
    const contentId = asPositiveInteger(message.contentId);
    if (contentId) return contentId;
  }

  const link =
    typeof message.url === "string"
      ? message.url
      : typeof message.href === "string"
      ? message.href
      : undefined;

  return link ? getChatbotContentIdFromUrl(link) : undefined;
};

export const getChatbotContentDetailsPath = (contentId: number) =>
  `/app/conteudo/detalhes/conteudos/${contentId}`;
